import TopBar from '@/pages/home/components/TopBar';
import Hero from '@/pages/home/components/Hero';
import SpeedFeed from '@/pages/home/components/SpeedFeed';
import HotRank from '@/pages/home/components/HotRank';
import Evidence from '@/pages/home/components/Evidence';
import FrontComments from '@/pages/home/components/FrontComments';
import Circles from '@/pages/home/components/Circles';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <>
      <TopBar />
      <main>
        <Hero />
        <SpeedFeed />
        <HotRank />
        <Evidence />
        <FrontComments />
        <Circles />
      </main>
      <Footer />
    </>
  );
}